import React, { useState, useEffect } from 'react';
import { Phone, Mail, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { mockData } from '../mock';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { id: 'home', label: 'Início' },
    { id: 'about', label: 'Sobre' },
    { id: 'programs', label: 'Programas' },
    { id: 'activities', label: 'Atividades' },
    { id: 'testimonials', label: 'Depoimentos' },
    { id: 'contact', label: 'Contato' }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-lg' 
          : 'bg-white/80 backdrop-blur-sm'
      }`}
    >
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-amber-400 to-yellow-300 text-gray-800 py-2 px-4">
        <div className="container mx-auto flex justify-between items-center text-sm">
          <div className="flex items-center gap-4">
            <a href={`tel:${mockData.school.phone}`} className="flex items-center gap-1 hover:text-gray-900 transition-colors">
              <Phone size={14} />
              <span className="hidden sm:inline">{mockData.school.phone}</span>
            </a>
            <a href={`tel:${mockData.school.phone2}`} className="flex items-center gap-1 hover:text-gray-900 transition-colors">
              <Phone size={14} />
              <span className="hidden lg:inline">{mockData.school.phone2}</span>
            </a>
            <a href={`mailto:${mockData.school.email}`} className="flex items-center gap-1 hover:text-gray-900 transition-colors">
              <Mail size={14} />
              <span className="hidden md:inline">{mockData.school.email}</span>
            </a>
          </div>
          <div className="text-xs font-medium">
            {mockData.school.yearsOfExperience} anos de tradição
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div 
            onClick={() => scrollToSection('home')}
            className="cursor-pointer flex items-center gap-3 group"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_bb20f472-f37c-4f14-a7f8-13b7abd8c0d5/artifacts/2l1s8394_Logo02.png"
              alt="Logo Recanto Abelhinha"
              className="h-16 w-auto group-hover:scale-105 transition-transform"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-6">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-gray-700 hover:text-amber-600 font-medium transition-colors relative group"
              >
                {item.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-amber-500 group-hover:w-full transition-all duration-300"></span>
              </button>
            ))}
            <Button 
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white shadow-md hover:shadow-lg transition-all"
            >
              Agende uma Visita
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-gray-800 hover:text-amber-600 transition-colors"
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-200 pt-4 space-y-3 animate-in slide-in-from-top">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="block w-full text-left text-gray-700 hover:text-amber-600 font-medium py-2 px-4 rounded-lg hover:bg-amber-50 transition-colors"
              >
                {item.label}
              </button>
            ))}
            <Button 
              onClick={() => scrollToSection('contact')}
              className="w-full bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white"
            >
              Agende uma Visita
            </Button>
          </div>
        )}
      </nav>
    </header>
  );
};
